import axios from 'axios';

import { API_BASE_URL } from '../config';

export const emailService = {
  /**
   * Envía correo de bienvenida a un nuevo usuario
   */
  sendWelcomeEmail: async (userData) => {
    try {
      const response = await axios.post(
        `${API_BASE_URL}/api/email?action=send_welcome_email`,
        {
          user_id: userData.user_id,
          email: userData.email,
          nombre: userData.nombre,
          usuario: userData.usuario,
          password: userData.password,
          template: userData.template // Incluir plantilla
        },
        {
          timeout: 10000,
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${localStorage.getItem('token') || ''}`
          }
        }
      );
      return response.data;
    } catch (error) {
      console.error('Error al enviar correo de bienvenida:', error.message);
      throw error;
    }
  },

  /**
   * Envía correo de restablecimiento de contraseña
   */
  sendPasswordResetEmail: async (email, nombre, resetLink) => {
    try {
      const response = await axios.post(
        `${API_BASE_URL}/api/email?action=send_password_reset`,
        {
          email: email,
          nombre: nombre,
          reset_link: resetLink
        },
        {
          timeout: 10000,
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${localStorage.getItem('token') || ''}`
          }
        }
      );
      return response.data;
    } catch (error) {
      console.error('Error al enviar correo de restablecimiento:', error.message);
      throw error;
    }
  },

  /**
   * Envía correo de cumpleaños
   */
  sendBirthdayEmail: async (userData) => {
    try {
      const response = await axios.post(
        `${API_BASE_URL}/api/email?action=send_birthday_email`,
        {
          email: userData.email,
          nombre: userData.nombre,
          cargo: userData.cargo,
          profilePicture: userData.profilePicture,
          template: userData.template // Incluir plantilla
        },
        {
          timeout: 10000,
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${localStorage.getItem('token') || ''}`
          }
        }
      );
      return response.data;
    } catch (error) {
      console.error('Error al enviar correo de cumpleaños:', error.message);
      throw error;
    }
  },

  /**
   * Envía correo de aniversario
   */
  sendAnniversaryEmail: async (userData) => {
    try {
      const response = await axios.post(
        `${API_BASE_URL}/api/email?action=send_anniversary_email`,
        {
          email: userData.email,
          nombre: userData.nombre,
          cargo: userData.cargo,
          profilePicture: userData.profilePicture,
          years: userData.years,
          template: userData.template // Incluir plantilla
        },
        {
          timeout: 10000,
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${localStorage.getItem('token') || ''}`
          }
        }
      );
      return response.data;
    } catch (error) {
      console.error('Error al enviar correo de aniversario:', error.message);
      throw error;
    }
  },

  /**
   * Obtiene el historial de correos enviados
   */
  getEmailHistory: async (filters = {}) => {
    try {
      const params = new URLSearchParams(filters);
      const response = await axios.get(
        `${API_BASE_URL}/api/email/history?${params}`,
        { timeout: 10000, headers: { Authorization: `Bearer ${localStorage.getItem('token') || ''}` } }
      );
      return response.data;
    } catch (error) {
      console.error('Error al obtener historial de correos:', error.message);
      throw error;
    }
  },

  /**
   * Envía correo de prueba con plantilla
   */
  sendTestEmail: async (templateData) => {
    try {
      const response = await axios.post(
        `${API_BASE_URL}/api/email/test`,
        templateData,
        {
          timeout: 10000,
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${localStorage.getItem('token') || ''}`
          }
        }
      );
      return response.data;
    } catch (error) {
      console.error('Error al enviar correo de prueba:', error.message);
      throw error;
    }
  }
};

export default emailService;
